import { TvoedData } from './tvoed-data.model';
import { TvoedExtraPaymentDefinition } from './tvoed-extra-payment.model';

export interface TvoedCalculatorState {
  labourAgreementId: string | null;
  subTable: string; // e.g. 'tvoed-vka', 'tvoed-bund', 'tvoed-sue', etc.
  payGrade: string; // e.g. 'E 12', 'S 8a', 'P 8'
  payGradeStep: string; // e.g. 'Stufe 1' .. 'Stufe 6'
  weeklyWorkingHours: number;
  weeklyAdditionalWorkingHours: number;
  additionalExtraPayment: number;
  zulagenSchicht: boolean;
  zulagenNacht: boolean;
  zulagenWochenende: boolean;
  zulagenUeberstunden: boolean;
  zulagenFunktion: boolean;
  leistungsentgeltAmount: number;
  rememberInputs: boolean;
  tvoedData: TvoedData | null;
  extraPaymentData: TvoedExtraPaymentDefinition[] | null;
}

export const initialTvoedCalculatorState: TvoedCalculatorState = {
  labourAgreementId: null,
  subTable: '',
  payGrade: '',
  payGradeStep: '',
  weeklyWorkingHours: 39,
  weeklyAdditionalWorkingHours: 0,
  additionalExtraPayment: 0,
  zulagenSchicht: false,
  zulagenNacht: false,
  zulagenWochenende: false,
  zulagenUeberstunden: false,
  zulagenFunktion: false,
  leistungsentgeltAmount: 0,
  rememberInputs: false,
  tvoedData: null,
  extraPaymentData: null
};
